/* This file is autogenerated, see readme.md for instructions */
import StopSvgIcon from '@bloomreach/banana-theme/icons/stop.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const StopIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <StopSvgIcon />
    </Icon>
  );
});

StopIcon.displayName = 'StopIcon';

export default StopIcon;
